import React from 'react';
import CloseButtonMui from 'react-bootstrap/CloseButton';
import { isTerminalVertical } from '../../utils';
import { UNIT } from '../../constants/configuration';

class CloseButton extends React.Component {
  render() {
    const { onClick, closeStyle } = this.props;
    return (
      <div className='row closeStyle' style={{ ...closeStyle }}>
        <CloseButtonMui
          className={` ${isTerminalVertical() && 'pt-2 pr-3'}`}
          onClick={() => {
            onClick();
          }}
        />
      </div>
    );
  }
}

export default CloseButton;
